import * as tslib_1 from "tslib";
import { Matrix3D } from "@awayjs/core";
import { ParticleStateBase } from "./ParticleStateBase";
/**
 * ...
 */
var ParticleRotateToHeadingState = (function (_super) {
    tslib_1.__extends(ParticleRotateToHeadingState, _super);
    function ParticleRotateToHeadingState(animator, particleNode) {
        var _this = _super.call(this, animator, particleNode) || this;
        _this._matrix = new Matrix3D();
        return _this;
    }
    ParticleRotateToHeadingState.prototype.setRenderState = function (shader, renderable, animationElements, animationRegisterData, projection, stage) {
        if (this._pParticleAnimator.animationSet.hasBillboard) {
            this._matrix.copyFrom(renderable.sourceEntity.transform.concatenatedMatrix3D);
            this._matrix.append(projection.transform.inverseConcatenatedMatrix3D);
            shader.setVertexConstFromMatrix(animationRegisterData.getRegisterIndex(this._pAnimationNode, ParticleRotateToHeadingState.MATRIX_INDEX), this._matrix);
        }
    };
    return ParticleRotateToHeadingState;
}(ParticleStateBase));
export { ParticleRotateToHeadingState };
/** @private */
ParticleRotateToHeadingState.MATRIX_INDEX = 0;



// WEBPACK FOOTER //
// ../dist/lib/animators/states/ParticleRotateToHeadingState.js